import { GetEcoaStudySitesRequest, GetEcoaStudySitesResponse } from "./EcoaSite.dto";
import { EcoaSiteUrl } from "./EcoaSite.url";
import { restReq } from "../../common/cyan.types";
import { FxApiRequestData, FxRequestData } from "../../common/flax.types";
import { extractKey } from "../../common/HttpRequest";

export class EcoaSiteFlax {
  public static getEcoaStudySites(data: FxRequestData<GetEcoaStudySitesRequest>): FxApiRequestData<GetEcoaStudySitesResponse> {
    const studyId = extractKey(data, "studyId");

    return {
      ...restReq(process.env.REACT_APP_CDMS_BE_URL, EcoaSiteUrl.getEcoaStudySites(studyId), data),
      reducer: resp => resp,
      errReducer: resp => resp,
    };
  }
}
